/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * NEXMAIL (Internal)
 * Internal API consumed by the nexmail dashboard.
 * OpenAPI spec version: 0.0.1
 */

export type StaffQueueControllerQueueV1View =
  (typeof StaffQueueControllerQueueV1View)[keyof typeof StaffQueueControllerQueueV1View];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StaffQueueControllerQueueV1View = {
  all: 'all',
  mine: 'mine',
  first_drafts: 'first_drafts',
  edits: 'edits',
  unassigned: 'unassigned',
  blocked: 'blocked',
  needs_lead: 'needs_lead',
} as const;
